import { storage as storageType } from '@/config'
class Storage {
  constructor() {}

  /**
   * @description 获取storage
   * @returns {string|ActiveX.IXMLDOMNode|Promise<any>|any|IDBRequest<any>|MediaKeyStatus|FormDataEntryValue|Function|Promise<Credential | null>}
   */
  get(name) {
    if (storageType) {
      if ('localStorage' === storageType) {
        return localStorage.getItem(name)
      } else if ('sessionStorage' === storageType) {
        return sessionStorage.getItem(name)
      } else {
        return localStorage.getItem(name)
      }
    } else {
      return localStorage.getItem(name)
    }
  }

  /**
   * @description 存储storage
   * @param value
   * @returns {void|*}
   */
  set(name, data) {
    if (storageType) {
      if ('localStorage' === storageType) {
        return localStorage.setItem(name, data)
      } else if ('sessionStorage' === storageType) {
        return sessionStorage.setItem(name, data)
      } else {
        return localStorage.setItem(name, data)
      }
    } else {
      return localStorage.setItem(name, data)
    }
  }
  /**
   * @description 移除storage
   * @returns {void|Promise<void>}
   */
  remove(name) {
    if (storageType) {
      if ('localStorage' === storageType) {
        return localStorage.removeItem(name)
      } else if ('sessionStorage' === storageType) {
        return sessionStorage.removeItem(name)
      } else {
        return localStorage.removeItem(name)
      }
    } else {
      return localStorage.removeItem(name)
    }
  }
}

const storage = new Storage()

export default storage
